<div class="blade-wrapper">
  <div class="blade-header">
    <div *ngIf="!$hasMissingRequiredInParams" class="blade-tools">
      <div data-cy="tool-id-confirm" *ngIf="!toolbar.confirm.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.confirm.control.readOnly"
              [ngStyle]="toolbar.confirm.control.styles.style"
              [ngClass]="toolbar.confirm.control.styles.classes"
              (click)="on_confirm_click($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.confirm.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.confirm.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.confirm.control.label}}</div>
        </div>
      
      </button>
      </div>
      <div data-cy="tool-id-cancel" *ngIf="!toolbar.cancel.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.cancel.control.readOnly"
              [ngStyle]="toolbar.cancel.control.styles.style"
              [ngClass]="toolbar.cancel.control.styles.classes"
              (click)="on_cancel_click($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.cancel.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.cancel.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.cancel.control.label}}</div>
        </div>
      
      </button>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized && !$hasMissingRequiredInParams">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-update_status"
                     *ngIf="!fieldsets.update_status.hidden"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.update_status.collapsible }">
                    <div *ngIf="!fieldsets.update_status.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.update_status.toggle()">
                      <span class="fieldsetsTitle-text">Lot status update</span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.update_status.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.update_status.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.update_status.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.update_status.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-message" *ngIf="!fields.message.hidden" 
                            class="field-container full {{fields.message.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.message.styles.style"
                            [ngClass]="fields.message.styles.classes">
                        <div class="label-container"
                              title="{{fields.message.label}}{{fields.message.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.message.label}}">{{fields.message.label}}<span *ngIf="fields.message.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" data-cy="textBox-multi"formControlName="message"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{fields.message.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.message.control.placeholder}}"
                                [ngStyle]="fields.message.control.styles.style"
                                [ngClass]="fields.message.control.styles.classes"> </textarea>
                        <ng-container *ngIf="fields.message.invalid">
                          <ng-container *ngFor="let error of fields.message.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-status" *ngIf="!fields.status.hidden" 
                            class="field-container standard {{fields.status.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.status.styles.style"
                            [ngClass]="fields.status.styles.classes">
                        <div class="label-container"
                              title="{{fields.status.label}}{{fields.status.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.status.label}}">{{fields.status.label}}<span *ngIf="fields.status.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <Lots-lot_statuses_dd_single 
                            data-cy="selector"
                            [type]="fields.status.control.type"
                            formControlName="status"
                            (displayTextChange)="fields.status.control.displayText=$event"
                            [placeholder]="fields.status.control.placeholder"
                            [styles]="fields.status.control.styles"
                        >
                        </Lots-lot_statuses_dd_single>
                        <ng-container *ngIf="fields.status.invalid">
                          <ng-container *ngFor="let error of fields.status.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-reason_codes" *ngIf="!fields.reason_codes.hidden" 
                            class="field-container standard {{fields.reason_codes.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.reason_codes.styles.style"
                            [ngClass]="fields.reason_codes.styles.classes">
                        <div class="label-container"
                              title="{{fields.reason_codes.label}}{{fields.reason_codes.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.reason_codes.label}}">{{fields.reason_codes.label}}<span *ngIf="fields.reason_codes.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <Lots-reason_codes_multi 
                            data-cy="selector-multi"
                            [type]="fields.reason_codes.control.type"
                            formControlName="reason_codes"
                            (displayTextChange)="fields.reason_codes.control.displayText=$event"
                            [placeholder]="fields.reason_codes.control.placeholder"
                            [styles]="fields.reason_codes.control.styles"
                        >
                        </Lots-reason_codes_multi>
                        <ng-container *ngIf="fields.reason_codes.invalid">
                          <ng-container *ngFor="let error of fields.reason_codes.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
                  </div>
                </div>
              </div>      </ng-container>

      <div *ngIf="$hasMissingRequiredInParams" class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>